// TODO: delete this file after code migrated to TS types generated from C#

import { IGpsCoordinates } from "./_generated/IGpsCoordinates";
import { TriggerZoneType } from "./_generated/TriggerZoneType";

export class GpsCoordinates implements IGpsCoordinates {
    constructor(
        latitude: number,
        longitude: number,
        altitude: number = 0
    ) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.altitude = altitude;
    }
    public latitude: number;
    public longitude: number;
    public altitude: number;
}

export interface ITriggerZone {
    userDirectionOfWalkingAzimuth?: number;
    type: TriggerZoneType;
    circleTypeGpsCoordinates?: IGpsCoordinates;
    circleTypeRadius?: number;
    polygonTypePolygonCorners?: IGpsCoordinates[];
}

export class TriggerZone implements ITriggerZone {
    constructor(
        type: TriggerZoneType,
        circleTypeGpsCoordinates?: IGpsCoordinates,
        circleTypeRadius?: number,
        polygonTypePolygonCorners?: IGpsCoordinates[]
        ) {
        this.type = type;
        this.circleTypeGpsCoordinates = circleTypeGpsCoordinates ? circleTypeGpsCoordinates : new GpsCoordinates(0, 0, 0);
        this.circleTypeRadius = circleTypeRadius ? circleTypeRadius : 0;
        this.polygonTypePolygonCorners = polygonTypePolygonCorners ? polygonTypePolygonCorners : new Array<GpsCoordinates>();
    }

    public userDirectionOfWalkingAzimuth?: number;
    public type: TriggerZoneType;
    public circleTypeGpsCoordinates: IGpsCoordinates;
    public circleTypeRadius: number;
    public polygonTypePolygonCorners: IGpsCoordinates[];
}

export class Circle {
    constructor(
        latitude: number,
        longitude: number,
        radius: number
    ) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.radius = radius;
    }
    public latitude: number;
    public longitude: number;
    public radius: number;
}
